<template>
  <div class="nopadding" id="sponsorslogos">
    TEST
  </div>
</template>
<style>

</style>
<script>
  import { mapGetters } from 'vuex'

  export default{
    data: function () {
      return {
        selectedCat: 'All Categories'
      }
    },
    computed: {
      ...mapGetters({
        mobile: 'mobile',
        sponsors: 'sponsors',
        getAthletes: 'athletes',
        categories: 'categories',
        race: 'focusedRace'
      }),
      sponsorMaxWidth: function () {
        let w = 100 / this.sponsors.length
        return {
          maxWidth: w + '%',
          padding: '2px',
          maxHeight: '45px'
        }
      },
      position () {

      }
    },
    methods: {
      sponsorUrlParse: function (url) {
        return url + '?h=60'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/sponsors.vue